import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const ThrobberGlobal = styled.div`
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 3;
`;

export const TextFeedbackWrapper = styled.div`
    flex-direction: column;
    gap: 8px;
    position: relative;
`;

export const SubTextFeedback = styled.div`
    ${FONTS.S};
    justify-content: center;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.XS};
    }
`;

export const TitleFeedback = styled(H3)`
    ${FONTS.H2};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.H3};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H4};
        text-align: center;
    }
`;
